import { Component } from '@angular/core';

@Component({
  selector: 'app-brand-cta-section',
  imports: [],
  templateUrl: './brand-cta-section.component.html',
  styleUrl: './brand-cta-section.component.css',
})
export class BrandCtaSectionComponent {

}
